import { Link } from "react-router-dom";
import { Anchor, ArrowLeft } from "lucide-react";

/**
 * LegalShell — shared chrome for /privacy, /terms, /support pages.
 * Minimal navy-on-cream layout matching brand. Public, no auth required.
 * Long-form content lives in children.
 */
export default function LegalShell({ title, subtitle, lastUpdated, children }) {
    return (
        <div data-testid="legal-page" style={{ minHeight: "100vh", background: "var(--bm-bg)" }}>
            <header style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "22px 32px", maxWidth: 1100, margin: "0 auto",
            }}>
                <Link to="/" data-testid="legal-brand-link" style={{
                    display: "inline-flex", alignItems: "center", gap: 10,
                    textDecoration: "none", color: "inherit",
                }}>
                    <Anchor size={20} color="var(--bm-gold)" />
                    <span className="bm-display" style={{ fontSize: 24 }}>Bosun's Mate</span>
                </Link>
                <Link to="/" data-testid="legal-home-link" className="bm-link" style={{
                    display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13,
                }}>
                    <ArrowLeft size={14} /> Home
                </Link>
            </header>

            <main style={{ maxWidth: 760, margin: "0 auto", padding: "20px 32px 80px" }}>
                <h1 className="bm-serif" style={{ fontSize: 40, margin: "16px 0 6px", fontWeight: 500, color: "var(--bm-text)" }}>
                    {title}
                </h1>
                {subtitle && (
                    <p style={{ color: "var(--bm-text-muted)", fontSize: 15, lineHeight: 1.55, margin: "0 0 6px" }}>
                        {subtitle}
                    </p>
                )}
                {lastUpdated && (
                    <p style={{ color: "var(--bm-text-dim)", fontSize: 12, margin: "0 0 30px", letterSpacing: "0.05em" }}>
                        Last updated · {lastUpdated}
                    </p>
                )}
                <div className="bm-legal-body" style={{
                    color: "var(--bm-text)", fontSize: 15, lineHeight: 1.75,
                }}>
                    {children}
                </div>
            </main>
        </div>
    );
}
